module.exports = __webpack_public_path__ + "img/wenzhangfenlei.b7b98673.png";